import React from 'react';
import { PreparedDataReturn, ProductDetail } from './interface';
import "./inventoryBulk.scss"


const Index = ({ data }: { data: PreparedDataReturn[] }) => {
    const findRowSpanLength = (value: PreparedDataReturn): number => {
        let maxValue = 0
        for (let i = 0; i < value?.product_details?.length; i++) {
            let newValue = value?.product_details[i]
            maxValue = newValue?.barcodes?.length
        }
        return maxValue + value?.product_details?.length
    };

    return (
        <div>
            <div className='lens_table_custom_table table-responsive'>
                <table className=' w-100 position-relative '>
                    <thead className='table-thead background-blue color-black position-sticky sticky-top '>
                        <tr>
                            <th>Store Code</th>
                            <th>Product ID</th>
                            <th>Barcode</th>
                            <th>Unit Cost</th>
                            <th>Remark</th>
                        </tr>
                    </thead>
                    <tbody className='mt-3 lens_table_table-tbody'>
                        {(data && data?.length > 0) && data?.map(productDetail => (
                            productDetail?.product_details?.map((item, index) => (
                                <tr className='p-1 lens_table_border-top ' key={`${item?.barcodes}${index}`}>
                                    {/* Store Code */}
                                    {index === 0 && (
                                        <td className='border-right lens_table_first_column'
                                            rowSpan={findRowSpanLength(productDetail)}>
                                            {productDetail?.store_code}
                                        </td>
                                    )}

                                    {/* Product ID */}
                                   {index  && <td className='border-right p-1'>
                                        <div className='row px-2 align-items-center'>
                                            <div className='col-9'>
                                                {/* <strong>{variety.title}</strong> */}
                                            </div>
                                        </div>
                                    </td>}

                                    {/* Unit Cost */}
                                    {/* <td className='border-right p-1'>
                                        <div className='row px-2 align-items-center'>
                                            <div className='col-9'>
                                                <strong>{variety.title}</strong>
                                            </div>
                                        </div>
                                    </td> */}

                                    {/* Remark */}
                                    {/* <td className='border-right p-1'>
                                        <div className='row px-2 align-items-center'>
                                            <div className='col-9'>
                                                <strong>{variety.title}</strong>
                                            </div>
                                        </div>
                                    </td> */}

                                    {/* Barcode */}
                                    {/* <td className=''>
                                        <div className='w-100' style={{ overflow: "hidden" }}>
                                            {variety?.AddOns?.map((addon, index) => {
                                                let appliedCss = index % 2 !== 0
                                                return (
                                                    <div key={addon?.id} className={`row pb-2 align-items-center ${appliedCss ? "lens_table_background_color_primary" : "lens_table_background_color_secondary"}`}>
                                                        <div className='col-9'>{addon?.title}</div>
                                                        <div className='col-3 pt-1'>
                                                            <Input
                                                                type="number"
                                                                value={addon.price}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handlePriceChange(e, lens.id, variety.id, addon.id)}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            )}
                                        </div>
                                    </td> */}
                                </tr>
                            ))
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Index;
